export const useCategory = async(
    category: MaybeRefOrGetter<Readonly<string>>,
    param: MaybeRefOrGetter<Readonly<string|string[]>>,
    pageRef: Ref<number>,
    label: MaybeRefOrGetter<Readonly<string>>|null = null,
) => {
    const route = useRoute();
    const { options } = await useCategoryFilter(
        category,
        label
    );

    const ids = getArray(route?.query?.[toValue(param)] ?? []);
    const selected = ref([]);

    watch(options, () => {
        selected.value = options.value
            ?.filter(({ id }) => ids.includes(id))
            ?.map(({ id }) => {
                return id;
            })[0];
    }, { immediate: true });

    syncRoute(selected, param, { page: 1 });
    watch(selected, () => {
        pageRef.value = 1;
    });

    return {
        options,
        selected,
        clear: () => {
            selected.value = [];
        }
    };
};
